import { render, staticRenderFns } from "./DetalhesProdutoDialog.vue?vue&type=template&id=64e87c62&scoped=true"
import script from "./DetalhesProdutoDialog.vue?vue&type=script&lang=js"
export * from "./DetalhesProdutoDialog.vue?vue&type=script&lang=js"
import style0 from "./DetalhesProdutoDialog.vue?vue&type=style&index=0&id=64e87c62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e87c62",
  null
  
)

export default component.exports